import React from "react";
import MobileModuleHeader from "../../components/MobileModuleHeader";
import { useAppDispatch, useAppSelector, useDebounce } from "../../app/hooks";
import { selectLabels } from "../../slices/language";
import { selectUser, selectUserRole } from "../../slices/user";
import { useNavigate } from "react-router-dom";
import { UnitData } from "../../api/models/units";
import api from "../../api";
import { CircularProgress } from "@mui/material";
import UnitCard from "../../components/UnitCard";
import { showError } from "../../utils/helpers";

const MobUnits = () => {
  const labels = useAppSelector(selectLabels);
  const userRole = useAppSelector(selectUserRole);
  const user = useAppSelector(selectUser);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const propertyId = user?.property?.id;

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [searchFilter, setSearchFilter] = React.useState<string>("");
  const [units, setUnits] = React.useState<UnitData[] | null>(null);
  const [page, setPage] = React.useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalUnits, setTotalUnits] = React.useState<number>(0);

  const fixedPage = React.useMemo(() => {
    return page + 1;
  }, [page]);

  const debouncedSearch = useDebounce(searchFilter, 300);

  const getUnits = React.useCallback(
    async (debouncedSearchText: string) => {
      try {
        setIsLoading(true);
        const response = await api.unitsRequest(
          Number(propertyId),
          fixedPage,
          rowsPerPage,
          debouncedSearchText
        );
        if (response) {
          setUnits(response?.data);
          const totalRows = response?.meta?.pagination?.total;
          setTotalUnits(totalRows);
        }
      } catch (error: any) {
        console.error(error);
        const errorMessage = error?.response?.data?.error?.message;
        showError(dispatch, errorMessage ? errorMessage : labels.generic_error);
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch, fixedPage, labels.generic_error, propertyId, rowsPerPage]
  );

  React.useEffect(() => {
    getUnits(debouncedSearch);
  }, [debouncedSearch, getUnits]);

  return (
    <div className="mobile-module-body" style={{ position: "relative" }}>
      <div
        style={{
          zIndex: 99,
          position: "relative",
        }}
      >
        <MobileModuleHeader
          title={labels.units}
          titleIcon={"heroicons:squares-2x2-20-solid"}
          searchValue={searchFilter}
          setSearchValue={setSearchFilter}
          hasSearch={true}
          hasFilters={false}
          isDowloadable={false}
          hasNewButton={userRole === "guard" ? false : true}
          newButtonAction={() => navigate("/new-unit")}
        />
      </div>
      <div
        className={"mobile-module-body-no-filters-content"}
        style={{ zIndex: 10, position: "relative" }}
      >
        {isLoading ? (
          <div className="w-100 h-100 flex justify-content-center align-items-center">
            <CircularProgress />
          </div>
        ) : (
          <>
            {units &&
              units.length > 0 &&
              units.map((item, index) => (
                <UnitCard
                  key={`${item?.id}-${index}`}
                  unit={item}
                  style={{
                    marginBottom: units.length - 1 === index ? 0 : 8,
                  }}
                  onPress={() =>
                    navigate(`/unit-details/${item?.documentId}/${propertyId}`)
                  }
                />
              ))}
          </>
        )}
      </div>
    </div>
  );
};

export default MobUnits;
